function getProductName(product) {
  let name = product.product_name,
      stock_desc = product.stock_description_1 + ' '
          + product.stock_description_2 + ' '
          + product.stock_description_3
  return name || stock_desc
}


function getCartThumbnail (product) {
  if (product.product_thumbnail) {
    return product.product_thumbnail
  }
  return null
}


function isAddToCartDisabled(product, isAddingToCart, isButtonDisabled) {
  const isNotReplenishable = isProductNotReplenishable(product);
  return (
    isNotReplenishable || isAddingToCart || isButtonDisabled
  );
}


function isProductComingSoon(product) {
  return product.inventory_order_handling === "coming_soon"
}


function isProductRetailersOnly(product) {
  return product.inventory_order_handling === "retailer"
}


function isProductNotReplenishable(product) {
  if (product.inventory_order_handling === "not_replenishable") {
    return (
      parseFloat(product.quantity_available) <= 0 ||
      product.quantity_available === null
    );
  }
  return false;
}


export default {
  getProductName,
  getCartThumbnail,
  isAddToCartDisabled,
  isProductNotReplenishable,
  isProductComingSoon,
  isProductRetailersOnly,
}



// WEBPACK FOOTER //
// ./ixcms/themes/src/vue-src/utils/productHelpers.js